import AppImage from '~/themes/base/components/atom/AppImage'

export default {
  extends: AppImage,
  props: {
    fetchpriority: {
      type: String,
      default: null, // 'high' | 'low' | null
    },
  },
  computed: {
    isHighPriority() {
      return this.fetchpriority === 'high'
    },
    loadingMode() {
      if (this.isHighPriority) {
        return 'eager'
      }
      return this.lazy ? 'lazy' : 'eager'
    },
    imageRatio() {
      return this.width && this.height ? 1 / (this.width / this.height) : null
    },
  },
}
